import Container from "@components/Atomic/Container/Container";
import React from "react";
import SellingPointsCircles from "./SellingPointsCircles";
import SellingPointsList from "./SellingPointsList";
import { withSellingPoints } from "./withSellingPoints";

const SellingPoints = withSellingPoints(
  ({ points, pointsWidth, style, styles }) => (
    <Container styles={styles} data-component-type="section-selling-points">
      {style === "list" ? (
        <SellingPointsList points={points} width={pointsWidth} />
      ) : null}
      {style === "circle" ? (
        <SellingPointsCircles points={points} width={pointsWidth} />
      ) : null}
    </Container>
  ),
);

export default SellingPoints;
